import React from 'react';
import ProjectCard from './CardProject';
import { projects } from './constants';

export default class ProjectFour extends React.Component {
    componentDidMount() {

        const $ = window.$;
        
        if ($(".img-popup").length) {
            var groups = {};
            $(".img-popup").each(function () {
              var id = parseInt($(this).attr("data-group"), 10);
        
              if (!groups[id]) {
                groups[id] = [];
              }
        
              groups[id].push(this);
            });
        
            $.each(groups, function () {
              $(this).magnificPopup({
                type: "image",
                closeOnContentClick: true,
                closeBtnInside: false,
                gallery: {
                  enabled: true,
                },
              });
            });
        }
          
    }
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="project-one-sec project-one-sec--three">
                    <div className="container">
                        <div className="row">
                            {projects.map(project => 
                                <ProjectCard 
                                    key={project.id}
                                    title={project.title}
                                    description={project.description}
                                    detailsUrl={project.detailsUrl}
                                    imageUrl={publicUrl + project.img}
                                    popupImageUrl={publicUrl + project.img}
                                    />
                            )}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}